import { Base64 } from 'js-base64';

import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import {
  fetchKnmHash,
  fetchSignKnm,
  fetchSignTestKnm,
  putSignerKnm,
  signKnm,
} from 'APIPackage/KnmModule/services/knmSignApi';
import { IPlanFormValues } from 'PlanPackage/MainModule/interfaces/PlanForm';

import { subscribe } from './cryptoHelpers';

export async function knmSignFunc(
  certificate: string,
  isErknm: boolean,
  knmId: IKnm['id'],
  actGuid?: string,
  prescriptionGuid?: string,
  form?: IPlanFormValues,
  isPm?: boolean,
  isCancelSign?: boolean,
  withPlan?: boolean,
) {
  const xmlData: string = await fetchKnmHash(knmId);

  if (isErknm || isPm) {
    const file = new Blob([xmlData]);
    const signature: string = await subscribe(xmlData, cadesplugin.CADESCOM_CADES_BES, certificate);

    if (form?.signerPosition && form?.signerFullName) {
      await putSignerKnm(knmId, form);
    }

    await fetchSignKnm({
      document: Base64.encode(xmlData),
      id: knmId,
      file,
      signature,
      fileName: `${String(knmId)}.xml`,
      actGuid,
      prescriptionGuid,
      isCancelSign,
      withPlan,
    });
  } else if (xmlData) {
    const signature: string = await subscribe(xmlData, cadesplugin.CADESCOM_CADES_BES, certificate);

    await signKnm(signature, knmId);
  }
}
export async function knmTestSignFunc(knmId: IKnm['id']) {
  await fetchSignTestKnm({ id: knmId });
}
